import Vue from 'vue'
import Router from 'vue-router'

import { store } from './store/store'
// Pages
import Confirmation from './views/Confirmation.vue'
import Dashboard from './views/Dashboard.vue'
import Tool from './views/Tool.vue'
import Order from './views/Order.vue'
import OrderDetails from './views/OrderDetails.vue'
import Account from './views/Account.vue'
import PasswordReset from './views/PasswordReset.vue'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifToolLoaded = (to, from, next) => {
  // If page is (re)loaded or the browser's 'previous' button is used, return to the dashboard
  if (from.name === null) {
    next('/')
    return
  }
  next()
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/password-reset/:token/:email',
      name: 'password-reset',
      component: PasswordReset,
      props: true,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/tool',
      name: 'tool',
      component: Tool,
      beforeEnter: ifToolLoaded
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/details/:order',
      name: 'order-details',
      component: OrderDetails,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: Confirmation,
      props: true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '*',
      beforeEnter(to, from, next) {
        console.log('page not found')
        next()
      },
      redirect: '/'
    }
  ]
})

export default router
